import React, { Component } from "react";
import BannerZip from "../Utils/GenericUI/Banner_zip.jsx";
import { Body } from "../Utils/StaticData/EnrollStepsStaticData";
import history from "../Utils/History";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { BrowserRouter } from "react-router-dom";
import { Text } from "react-internationalization";
import { connect } from "react-redux";
import AutoComplete1 from "../Utils/GenericUI/Select";
import TextField from "@material-ui/core/TextField";
import { VERDA_CONSTS } from "../Utils/StaticData/Constant";

import {
  agentCategoryDashboard,
  setStateParams,
  setLoginStateParams,
  setLoginStateValues,
  getPlans,
  yearSelection,
  getZipCodes,
  planSelectionContinue,
  setEnrollRedirect,
  getAgentIDListInPreEnrollForm,
  setPendingApplFlag,
  loadAppList,
  setPageName,
} from "../Redux/Actions/webAppActions";
import LoadApplModal from "./ContinuePrevApp/LoadApplModal.js";
import { FieldLabel, LANG } from "./translations/dynamic.js";

class EnrollSteps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      planNotAvailable: false,
      errorMsg: "",
      year: new Date().getFullYear().toString(),
      displayZipCode: false,
      countySelect: "",
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      snackBarOpen: false,
      pendingAppList: [{ label: "Select", value: "" }],
      appNum: "",
      showModal: false,
      month: new Date().getMonth(),
    };
  }
  async componentDidMount() {
    if (JSON.parse(window.sessionStorage.getItem("keyCloakData"))) {
      await this.props.setLoginStateParams(
        "agencyIDSelected",
        window.sessionStorage.getItem("agencyId")
      );
      let keyCloakData = JSON.parse(
        window.sessionStorage.getItem("keyCloakData")
      );
      let { firstName, lastName, agentDetails, tokenExpiry, userId } =
        keyCloakData;
      let data2 = {
        firstName: firstName ?? "",
        lastName: lastName ?? "",
        agentFullName: agentDetails?.agentName ?? "",
        agentPhone: agentDetails?.agentPhone ?? "",
        agentId: agentDetails?.agentId ?? "",
        idleTime: tokenExpiry ?? "",
        userId: userId ?? "",
        agentEmailId: agentDetails?.agentEmail ?? "",
      };
      await this.props.setLoginStateValues(data2);
    }
    this.props.setLoginStateParams(
      "token",
      window.sessionStorage.getItem("token")
    );
    this.props.setLoginStateParams(
      "customerId",
      window.sessionStorage.getItem("customerId")
    );
    {
      JSON.parse(window.sessionStorage.getItem("agentLoggedIn")) &&
        this.props.setLoginStateParams(
          "agentLoggedIn",
          JSON.parse(window.sessionStorage.getItem("agentLoggedIn"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("beneficiaryLogin")) &&
        this.props.setLoginStateParams(
          "beneficiaryLogin",
          JSON.parse(window.sessionStorage.getItem("beneficiaryLogin"))
        );
    }
    {
      JSON.parse(window.sessionStorage.getItem("guestLogin")) &&
        this.props.setLoginStateParams(
          "guestLogin",
          JSON.parse(window.sessionStorage.getItem("guestLogin"))
        );
    }

    await this.props.setStateParams("year", this?.state?.year);
    this.props.setPageName("select-pin");
    this.props.setStateParams("Submitted", false);
    this.props.setStateParams("guestbeneagentAppNum", null);
    this.props.setStateParams("appNum", null);
    this.props.setStateParams("count", null);
    this.props.setStateParams("pendingApplFlag", false);
    this.props.setStateParams("preEnrollInfo", {});
    this.props.setLoginStateParams("selectedPlan", "");
    await this.props.setStateParams("planType", "");
    await this.props.setStateParams("product", "");
    if (this.props.token === "") {
      if (window.sessionStorage.getItem("agentLogin") === "true") {
        await this.props.setLoginStateParams(
          "agentEmailId",
          window.sessionStorage.getItem("email")
        );
        this.props.setLoginStateParams(
          "firstName",
          window.sessionStorage.getItem("firstName")
        );
        this.props.setLoginStateParams("agentLoggedIn", true);
        this.props.setLoginStateParams(
          "agentId",
          window.sessionStorage.getItem("agentId")
        );
        this.props.setLoginStateParams(
          "agencyIDSelected",
          window.sessionStorage.getItem("agencyId")
        );
        this.props.setStateParams("guestLoggedIn", false);
        this.props.setLoginStateParams("guestLogin", false);
      }
      if (
        window.sessionStorage.getItem("guestLogin") === "false" &&
        window.sessionStorage.getItem("agentLogin") === "false"
      ) {
        this.props.setLoginStateParams(
          "emailAddress",
          window.sessionStorage.getItem("email")
        );
        this.props.setLoginStateParams(
          "firstName",
          window.sessionStorage.getItem("firstName")
        );
        this.props.setStateParams("guestLoggedIn", false);
        this.props.setLoginStateParams("guestLogin", false);
        this.props.setLoginStateParams(
          "authenticatedData",
          JSON.parse(window.sessionStorage.getItem("authenticatedData"))
        );
      }
    }
    if (!this.props.agentLoggedIn && !this.props.guestLogin) {
      await this.props.loadAppList({
        emailId: this.props.emailId,
        customerId: this.props.customerId,
        userId: this.props.userId,
      });
      let apps = this.props.pendingAppList;
      apps && apps.unshift({ label: "Select", value: "" });
      this.setState({
        ...this.state,
        pendingAppList: apps,
      });
    }
    //checking user session....
    if (
      !this.props.agentLoggedIn &&
      !this.props.guestLogin &&
      !this.props.beneficiaryLogin
    ) {
      history.push("/e-Enroll/Login");
    }
  }
  async componentWillMount() {
    if (this.props.token === "") {
      if (
        window.sessionStorage.getItem("guestLogin") === "false" &&
        window.sessionStorage.getItem("agentLogin") === "false"
      ) {
        this.props.setLoginStateParams(
          "authenticatedData",
          JSON.parse(window.sessionStorage.getItem("authenticatedData"))
        );
      }
    }
  }
  modalClose = () => {
    this.setState({
      ...this.state,
      showModal: !this.state.showModal,
    });
  };
  handleSelectChange = async (event) => {
    let value = event.target ? event.target.value : event.value;
    value = value.replace(/[^0-9]+/g, "");
    await this.setState({ value: value });
    let response = "";
    if (this.props.token === "") {
      await this.props.setLoginStateParams(
        "token",
        window.sessionStorage.getItem("token")
      );
    }

    if (value.length === 5) {
      if (value) {
        this.props.setStateParams("zipCodes", {});
        response = await this.props.getZipCodes(value);
        this.props.setStateParams("zipCodeCheck", response?.status);
        this.props.setStateParams("zip", value);
        window.sessionStorage.setItem("zipcode", value);
      }
      if (this.props.ZipCodes && this.props.ZipCodes.length === 0) {
        this.setState({
          planNotAvailable: true,
          displayZipCode: false,
          errorMsg: response.message,
        });
      } else if (this.props.ZipCodes && this.props.ZipCodes.length > 0) {
        this.setState({
          planNotAvailable: false,
          displayZipCode: true,
        });
      }
    } else {
      this.setState({
        planNotAvailable: true,
        errorMsg:
          this.props.lang === "es"
            ? "Por favor ingrese un código postal válido."
            : "Please enter a valid zip code.",
        displayZipCode: false,
      });
    }
  };
  dashboardredirect = async (e) => {
    e.preventDefault();
    let emailaddr = this.props.agentEmailId;
    await this.props.agentCategoryDashboard(
      {
        applId: "",
        startDate: "",
        endDate: "",
        firstName: "",
        lastName: "",
        agentUserId: this.props?.isSuperUser ? "" : this?.props?.userId,
      },
      this.props?.customerId,
      emailaddr,
      this.props?.agentId,
      this.props?.agencyIDSelected
    );
    history.push("/e-Enroll/dashboard");
  };
  redirect = async (event) => {
    if (this.props.token === "") {
      this.props.setLoginStateParams(
        "token",
        window.sessionStorage.getItem("token")
      );
    }
    this.props.setStateParams("zipCodes", []);
    const response = await this.props.setEnrollRedirect(
      this.state.appNum,
      this.props.emailId,
      this.props?.customerId
    );
    if (response?.status === "OK") {
      await this.props.setLoginStateParams(
        "productId",
        response?.data?.productId
      );
      if (this.props.customerId === VERDA_CONSTS.ID) {
        if (
          new Date().getFullYear().toString() >
          response?.data?.proposedEffDate?.split("/")[2]
        ) {
          await this.props.yearSelection({
            planYear: new Date().getFullYear().toString(),
          });
        } else {
          await this.props.yearSelection({
            planYear: response?.data?.proposedEffDate?.split("/")[2],
          });
        }
      }
      if (this.props.customerId != VERDA_CONSTS.ID) {
        await this.props.yearSelection({
          planYear: response?.data?.proposedEffDate?.split("/")[2],
        });
      }
      let body = { customerId: this.props?.customerId };
      await this.props.getZipCodes(response.data.permanentAddress?.zipCode);
      const params = this.props.ZipCodes.filter(
        (zipcode1) =>
          zipcode1.countyName === response.data.permanentAddress?.county
      );
      await this.props.getPlans(
        response.data.permanentAddress?.zipCode,
        response.data.permanentAddress?.countyCd,
        body.customerId,
        params[0]?.stateCode,
        this?.props?.year
      );
      let plnType = this.props.cardDetails.filter(
        (x) => x.productId === response.data.productId
      );
      await this.props.setStateParams("planType", plnType[0]?.planType);
      await this.props.setStateParams(
        "zip",
        response.data.permanentAddress?.zipCode
      );
      await this.props.setStateParams(
        "stateId",
        response.data.permanentAddress?.state
      );
      await this.props.setStateParams(
        "CountyCd",
        response.data.permanentAddress?.countyCd
      );
      await this.props.setStateParams(
        "county",
        response.data.permanentAddress?.county
      );
      event.preventDefault();
      this.props.setLoginStateParams("selectedPlan", plnType[0]?.planId);
      const response1 = await this.props.planSelectionContinue(
        {
          planId: plnType[0]?.planId,
          premiumAmount: this.props.preEnrollInfo.premiumAmount,
          productId: this.props.preEnrollInfo.productId,
          customerId: this.props.preEnrollInfo.customerId,
        },
        this.props?.customerId
      );
      if (response1.status === "OK") {
        {
          this.props?.agentLoggedIn === true &&
            this.props?.customerId !== VERDA_CONSTS.ID &&
            (await this.props.getAgentIDListInPreEnrollForm(
              this.props?.customerId
            ));
        }
        await this.props.setPendingApplFlag(true);
        await this.props.setStateParams("appNum", this.state.appNum);
        history.push("/e-Enroll/enrollOnline");
      }
    } else {
      this.setState({
        ...this.state,
        snackBarOpen: true,
        snackBarMsg:
          "Error occured while loading data.Please try after some time",
        snackBarSeverty: "error",
        vertical: "top",
      });
    }
  };
  continue = async (event) => {
    event.preventDefault();
    let zipcode = this.state.value;

    if (zipcode.length === 5) {
      let call = true;

      if (this.props.ZipCodes && this.props.ZipCodes.length === 1) {
        await this.props.setStateParams(
          "county",
          this.props.ZipCodes[0].countyName
        );
        window.sessionStorage.setItem(
          "countySelect",
          this.props.ZipCodes[0].countyName
        );
      } else if (
        this.props.ZipCodes &&
        this.props.ZipCodes.length > 1 &&
        this.state.countySelect !== ""
      ) {
        await this.props.setStateParams("county", this.state.countySelect);
      } else {
        call = false;
        if (this.props.zipCodeCheck === "OK") {
          this.setState({
            planNotAvailable: true,
            errorMsg:
              this.props.lang === "es"
                ? "Seleccione un condado"
                : "Please Select a County",
          });
        } else {
          this.setState({
            planNotAvailable: true,
            errorMsg:
              this.props.lang === "es"
                ? "Ingrese el código postal correcto"
                : "Please enter proper zipcode",
          });
        }
      }

      if (call === true) {
        const params = this.props.ZipCodes.filter(
          (zipcode1) => zipcode1.countyName === this.props.county
        );

        let body = { customerId: this.props?.customerId };
        await this.props.getPlans(
          zipcode,
          params[0].countyCode,
          body.customerId,
          params[0].stateCode,
          this?.props?.year
        );

        if (this.props.planData && this.props.planData.length > 0) {
          let payload = { planYear: this.state.year };
          if (
            this.state.year === "2022" ||
            this.state.year === "2023" ||
            this.state.year === "2024" ||
            this.state.year === "2025"
          ) {
            this.props.yearSelection(payload);
            await this.props.setStateParams("preEnrollInfo", {});
            window.sessionStorage.setItem("year", this?.props?.year);
            history.push("/e-Enroll/select-plan");
            this.setState({
              planNotAvailable: false,
            });
          } else {
            this.setState({
              planNotAvailable: true,
              errorMsg:
                this.props.lang === "es"
                  ? "Seleccione un año"
                  : "Select a Year",
            });
          }
        } else {
          this.setState({
            planNotAvailable: true,
            errorMsg:
              this.props.lang === "es"
                ? "No hay planes disponibles para el código postal anterior."
                : "No plans available for the above zip code.",
          });
        }
      }
    } else {
      this.setState({
        planNotAvailable: true,
        errorMsg:
          this.props.lang === "es"
            ? "¡Ingrese el código postal correcto!"
            : "Please enter proper zip code!",
      });
    }
  };

  handleChangeYear = (name) => (event) => {
    let value = "";
    value = event.target ? event.target.value : event.value;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    this.props.setStateParams("year", value);
  };
  handleChange = (event) => {
    let value = event.target ? event.target.value : event.value;
    let name = event.target ? event.target.name : event.name;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if ((name = "countySelect")) {
      let state = this.props.ZipCodes.filter((zip) =>
        zip.countyName.includes(value)
      );
      this.props.setStateParams("stateId", state[0].stateCd);
    }

    window.sessionStorage.setItem("countySelect", value);
  };
  handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  render() {
    const { value, errorMsg, planNotAvailable, displayZipCode, countySelect } =
      this.state;
    const { ZipCodes } = this.props;
    let todayIs = new Date();
    let currentYear = todayIs.getFullYear();
    let nextYear = currentYear + 1;
    let previousYear = currentYear - 1;
    let yearOptions = [
      { label: "SELECT", value: "" },
      {
        label: currentYear.toString(),
        value: currentYear.toString(),
      },
    ];
    // Check if we are in the period between October and December
    if (todayIs.getMonth() >= 9) { 
      yearOptions.push({
        label: nextYear.toString(),
        value: nextYear.toString(),
      });
    }
    // If it's a new year, remove the last year
    if (todayIs.getMonth() === 0 && todayIs.getDate() === 1) { 
      yearOptions = yearOptions.filter(option => option.value !== previousYear.toString());
    }

    const { vertical, horizontal, snackBarSeverty, snackBarMsg } = this.state;
    return (
      <div>
        <Snackbar
          open={this.state.snackBarOpen}
          autoHideDuration={6000}
          onClose={this.handleSnackClose}
          anchorOrigin={{ vertical, horizontal }}
          key={this.state.vertical + this.state.horizontal}
        >
          <Alert onClose={this.handleSnackClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>
        {/* <Header /> */}
        {/* <HeaderContainer/> */}

        <div class="content-area">
          {this.props.agentLoggedIn === true && (
            <nav class="navbar navbar-dark custNavBar custNavBar2">
              <a
                class="navbar-brand navig-link"
                onClick={this.dashboardredirect}
              >
                Dashboard
              </a>
            </nav>
          )}

          <BrowserRouter>
            <div class="jumbotron-webApp">
              <BannerZip header={""} Body={Body} />
              <div class="container-Cambia container-height">
                <div class="tab-content-zipCode">
                  <div class=" form-panel">
                    <div class="form-group row">
                      <div class="col-md-12 text-center">
                        <label class="control-label">
                          <Text id="zipcode.head" />:{" "}
                        </label>
                        <br />
                        <div className="permanent-zip-container">
                          <React.Fragment>
                            <div class="onboarding__input-wrapper">
                              {displayZipCode === false ? (
                                <React.Fragment>
                                  <input
                                    type="text"
                                    name="permanentZip"
                                    id="permanentZip"
                                    value={value}
                                    minlength="5"
                                    maxlength="5"
                                    required
                                    onChange={this.handleSelectChange}
                                    placeholder={
                                      this.props.lang === "es"
                                        ? "Ingresa tu código postal"
                                        : "Enter Zip code"
                                    }
                                    autofocus="autofocus"
                                    autoComplete="off"
                                    spellcheck="false"
                                    aria-autocomplete="both"
                                    aria-haspopup="false"
                                  />
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  <div class="label fill">
                                    <span>{value}</span>
                                    <i
                                      class="fas fa-times-circle remove"
                                      onClick={() => {
                                        this.setState({
                                          displayZipCode: false,
                                          countySelect: "",
                                          value: "",
                                        });
                                      }}
                                    ></i>
                                  </div>
                                  {ZipCodes.length > 1 ? (
                                    <React.Fragment>
                                      {countySelect !== "" ? (
                                        <div class="label fill">
                                          <span>{countySelect}</span>
                                          <i
                                            class="fas fa-times-circle remove"
                                            onClick={() => {
                                              this.setState({
                                                countySelect: "",
                                              });
                                            }}
                                          ></i>
                                        </div>
                                      ) : (
                                        <div class="onboarding__select-wrapper select-active">
                                          <select
                                            id="countySelect"
                                            name="countySelect"
                                            value={countySelect}
                                            onChange={this.handleChange}
                                          >
                                            <option value="">
                                              {
                                                LANG.TRANSANY[this.props.lang]
                                                  .SACITY
                                              }
                                            </option>

                                            {ZipCodes.map((county) => (
                                              <option value={county.countyName}>
                                                {county.countyName}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ) : (
                                    <div class="label fill">
                                      <span>{ZipCodes[0]?.countyName}</span>
                                    </div>
                                  )}
                                </React.Fragment>
                              )}
                            </div>
                          </React.Fragment>
                        </div>

                        <div class="dropdown-container">
                          <AutoComplete1
                            handleChange={this.handleChangeYear("year")}
                            label={<Text id="zipcode.planyear" />}
                            options={yearOptions}
                            defaultValue={yearOptions.find(
                              (data) => data.value === this.state.year
                            )}
                            value={yearOptions.find(
                              (data) => data.value === this.state.year
                            )}
                            name="planYear"
                            margin="20px auto"
                          />
                        </div>
                      </div>
                      {planNotAvailable ? (
                        <div className="zip-err-msg">
                          <p class="error-label">{errorMsg}</p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div class="text-center">
                      <button
                        class={"btn-primary-continue mb-3"}
                        onClick={this.continue}
                      >
                        <Text id="zipcode.Continue" />
                      </button>
                    </div>
                    {this.props.agentLoggedIn === false &&
                    this.props.guestLogin === false &&
                    this.props.pendingAppList?.length > 1 ? (
                      <div class="text-center mt-3">
                        <a
                          onClick={this.modalClose}
                          className="continue-prev-link"
                        >
                          <Text id="zipcode.cpa" />
                        </a>
                      </div>
                    ) : null}

                    <LoadApplModal
                      showModal={this.state.showModal}
                      modalClose={this.modalClose}
                      handleChangeYear={this.handleChangeYear}
                      appNum={this.state.appNum}
                      redirect={this.redirect}
                      pendingAppList={this.state.pendingAppList}
                      agentLoggedIn={this.props.agentLoggedIn}
                    />
                  </div>
                </div>
              </div>
            </div>
          </BrowserRouter>
          {/* <div className="zip-footer"> */}
          {/* <Footer1 /> */}
          {/* <FooterContainer/> */}
          {/* </div> */}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    planData: state.webApp.planCardData,
    stateCd: state.webApp.stateCd,
    emailId: state.login.emailAddress
      ? state.login.emailAddress
      : window.sessionStorage.getItem("email"),
    ZipCodes: state.webApp.zipCodes,
    zipCode: state.webApp.zip,
    county: state.webApp.county,
    agentLoggedIn: state.login.agentLoggedIn,
    guestLogin: state.login.guestLogin,
    beneficiaryLogin: state.login.beneficiaryLogin,
    preEnrollInfo: state.webApp.preEnrollInfo,
    authenticatedData: state.login.authenticatedData,
    count: state.webApp.count,
    token: state.login.token,
    firstName: state.login.firstName,
    agentEmailId: state.login.agentEmailId,
    emailAddress: state.login.emailAddress,
    zipCodeCheck: state.webApp.zipCodeCheck,
    pendingAppList: state.login.pendingAppList,
    cardDetails: state.webApp.planCardData,
    customerId: state.login.customerId
      ? state.login.customerId
      : window.sessionStorage.getItem("customerId"),
    agencyIDSelected: state.login.agencyIDSelected,
    agentId: state.login.agentId,
    lang: state.webApp.language,
    userId: state.login.userId
      ? state.login.userId
      : window.sessionStorage.getItem("userId"),
    theme: state.login.theme,
    customerSubdomainDetails: state.login.customerSubdomainDetails,
  };
};
const mapDispatchToProps = {
  getAgentIDListInPreEnrollForm,
  setStateParams,
  agentCategoryDashboard,
  setLoginStateParams,
  setLoginStateValues,
  getPlans,
  yearSelection,
  getZipCodes,
  planSelectionContinue,
  setEnrollRedirect,
  setPendingApplFlag,
  loadAppList,
  setPageName,
};
export default connect(mapStateToProps, mapDispatchToProps)(EnrollSteps);
